<template>
  <el-header  class="clear">
      <div class="logo-wrap fl">
        <img :src="systemLogo" alt="logo" class="logo" />
        <i class="iconfont menu-btn fr" @click="switchConWidth">&#xe634;</i>
      </div>
      <!-- 退出 -->
      <i class="iconfont quit-btn fr" @click="quitSystem">&#xe659;</i>
      <!-- 用户 -->
      <div class="user-con fr" :title="uName" @click="goaccountManagement">
<!--        <img src="../assets/images/header/header_default.png" alt="" />-->
        <img  v-if="noImg" src="../assets/images/header/header_default.png" alt="" />
        <img v-else :src="imgSrc" alt="" />
      </div>
      <!-- 日期 -->
      <div class="date-con fr">
        <p>{{ date }}</p>
        <p>{{ time }}</p>
      </div>
      <div class="r-bar fl clear">

        <!-- tag标签 -->
        <div class="tags-wrap fl">
          <span
              class="tab-icon tab-prev"
              v-if="tagNavFlag"
              @click="changeTabs('prev')"
          >
            <i class="el-icon-arrow-left"></i>
          </span>
          <span
              class="tab-icon tab-next"
              v-if="tagNavFlag"
              @click="changeTabs('next')"
          >
            <i class="el-icon-arrow-right"></i>
          </span>
          <div class="tag-scroll clear">
            <ul class="tag-list">
              <li
                  class="tags-li"
                  v-for="(item, index) in tagsList"
                  :class="isActive(item.path) ? 'active' : ''"
                  :key="index"
              >
                <router-link :to="item.path" class="tags-li-title">
                  {{ item.title }}
                </router-link>
                <span class="close-current-tag" @click="closeTags(index)">
                  <i class="iconfont">&#xe71b;</i>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-header>

</template>

<script>
  import bus from "../assets/js/tools/bus";
  import { getNowFormatDate, getNowTime, getSession } from "../assets/js/tools/instruments";
  import cookie from 'vue-cookies'
  import axios from "axios"
export default {
  name: "headerCon",
  data() {
    return {
      collapsed: false,
      uName: "",
      noImg: true,
      imgSrc: "",
      tagNavFlag: false,
      tagsList: [],
      curOffset: 0, //tag滚动条的偏移量
      among: 0, //tagList超出scroll的值,
      date: getNowFormatDate(),
      time: getNowTime(),
      timer: null,
      generalSituation: false,
      headImgSrc: "",
      systemLogo: 'logo'
    };
  },
  mounted() {
    this.collapsed = this.$cookie.get('indexPage')=='GISOverview';
    this.generalSituation = getSession('generalSituation');
    this.headImgSrc = this.$store.state.userPic;
    this.changeHeadImg();
    let logoName = cookie.get('logo') ? cookie.get('logo') : 'logo';
    this.systemLogo = require('../assets/images/header/' + logoName + '.png');
  },
  computed: {
    showTags() {
      return this.tagsList.length > 0;
    },
    userPic() {
      return this.$store.state.userPic
    }
  },
  watch: {
    $route(newValue) {
      this.setTags(newValue);
    },
    userPic(val){
      if( val !== this.headImgSrc ){
        this.headImgSrc = val
        this.changeHeadImg();
      }
    }
  },
  created() {
    this.setTags(this.$route);
    // 监听关闭当前页面的标签页
    bus.$on("close_current_tags", () => {
      for (let i = 0, len = this.tagsList.length; i < len; i++) {
        const item = this.tagsList[i];
        if (item.path === this.$route.fullPath) {
          if (i < len - 1) {
            this.$router.push(this.tagsList[i + 1].path);
          } else if (i > 0) {
            this.$router.push(this.tagsList[i - 1].path);
          } else {
            this.$router.push("/");
          }
          this.tagsList.splice(i, 1);
        }
      }
    });
    this.interval();
  },
  methods: {
    switchConWidth(){
      this.collapsed = !this.collapsed;
      this.$emit('stateCollapse', this.collapsed)
    },
    /*
     * 前后切换tab标签
     * @param type prev:前/ next:后
     * */
    changeTabs: function(type) {
      let domTagList = document.getElementsByClassName("tag-list");
      if (type === "prev") {
        if (this.curOffset > -170) {
          //有偏移量
          this.curOffset = 0;
        } else {
          this.curOffset = this.curOffset + 180;
        }
      } else {
        if (Math.abs(this.among) < Math.abs(this.curOffset) + 150) {
          return false;
        }
        this.curOffset = this.curOffset - 180;
      }
      this.setCss(
        domTagList[0],
        "transform",
        "translateX(" + this.curOffset + "px)"
      );
    },
    /*
     * 获取当前tag的路径
     * @param path：路径
     * */
    isActive(path) {
      return path.indexOf(this.$route.path) != -1;
    },
    /*
     * 关闭tag标签
     * @param index:要关闭的标签的索引
     * */
    closeTags(index) {
      const delItem = this.tagsList.splice(index, 1)[0];
      //判断tag长度超出宽度 显示左右按钮
      let domTagList = document.getElementsByClassName("tag-list");
      let tagLen = domTagList.length ? domTagList[0].offsetWidth : 0;
      let domTagScroll = document.getElementsByClassName("tag-scroll");
      let scrollW = domTagScroll.length ? domTagScroll[0].offsetWidth : 0;
      if (this.curOffset < 0) {
        this.among = tagLen - scrollW + 180;
        this.curOffset = this.curOffset + 180;
        this.setCss(
          domTagList[0],
          "transform",
          "translateX(" + this.curOffset + "px)"
        );
      } else {
        this.tagNavFlag = false;
        if (domTagList[0]) {
          this.setCss(domTagList[0], "transform", "translateX(0px)");
        }
      }
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      let indexPage = '/'+ cookie.get('indexPage');
      if (item && item.path != indexPage) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push(indexPage);
        this.setTags(this.$route)
      }
    },
    /*
     * 设置标签
     * @ param route: 路由
     * */
    setTags(route) {
      const isExist = this.tagsList.some(item => {
        return item.path.indexOf(route.path) != -1;
      });
      if (!isExist) {
        if(route.matched[1]){
          this.tagsList.push({
            title: route.meta.title,
            path: route.fullPath,
            name: route.matched[1].components.default.name
          });
        }
        //判断tag长度超出宽度 显示左右按钮

        //实际tab总长
        let domTagList = document.getElementsByClassName("tag-list");
        let tagLen = domTagList.length ? domTagList[0].offsetWidth : 0;
        tagLen += 190; //tab增加一个时视图目前没有增加，此处为fix做法

        //tab容器宽度
        let domTagScroll = document.getElementsByClassName("tag-scroll");
        let scrollW = domTagScroll.length ? domTagScroll[0].offsetWidth : 0;
        //当实际长度超出容器时
        if (scrollW > 0 && scrollW < tagLen) {
          this.among = tagLen - scrollW + 190;
          this.tagNavFlag = true;
          this.curOffset = -Math.abs(scrollW - tagLen) - 10;
          this.setCss(
            domTagList[0],
            "transform",
            "translateX(" + this.curOffset + "px)"
          );
        } else {
          this.tagNavFlag = false;
          if (domTagList[0]) {
            this.setCss(domTagList[0], "transform", "translateX(0px)");
          }
        }
      }
      bus.$emit("tags", this.tagsList);
    },
    /*
     * 设置css样式
     * @params dom: 要设置样式的DOM元素/ attr: 样式属性/ val: 属性值
     */
    setCss: function(dom, attr, val) {
      return (dom.style[attr] = val);
    },
    /*
     * 退出系统
     * */
    quitSystem: function() {
      this.$store.commit('quitPage')
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          // this.$get("login/logout").then(() => {
        axios.get('http://case.bz-link.net/s1/passport/logout').then(() => {
            this.$router.push("/login");
            this.$store.commit('cancelQuitPage');
            this.$cookie.set('companyInfoId', '');
            this.$cookie.set('indexPage', '');

            // if (res.status === 200) {
            //   this.$router.push("/login");
            // } else {
            //   this.$message({
            //     message: res.msg,
            //     type: "error"
            //   });
            // }
          });
        })
        .catch(() => {
          this.$store.commit('cancelQuitPage')
        });
    },
    /*
    * 综合概况页跳转
    * */
    goGeneralSituation(){
      this.$router.push('/generalSituation')
    },
    /*
    * 账号管理页面跳转
    * */
    goaccountManagement(){
      this.$router.push('/accountManagement')
    },
    /*
    * 定时刷新时间
    * */
    interval(){
      let _this = this;
      this.timer = setInterval(function(){
        _this.time = getNowTime();
      }, 1000)
    },
    /*
    * 更新用户头像
    * */
    changeHeadImg() {
      if( this.headImgSrc ){
        this.noImg = false;
        this.imgSrc = this.headImgSrc;
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .el-header{
    padding: 0;
    width: 100%;
    //border-bottom: 1px solid #042d44;
    //background: rgba(9a,50, 78, 0.2);
    @include background_color("background_color_header");
    margin-bottom: 5px;
    .iconfont {
      @include font_color("iconfont_color_header");
      cursor: pointer;
      font-size: 30px;
      &.menu-btn {
        /*margin-right: 10px;*/
      }
    }
    .logo-wrap{
      width: 235px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      .logo {
        display: inline-block;
        //width: 155px;
        height: 45px;
        margin-top: 10px;
      }
    }
    /*退出*/
    .quit-btn {
      padding: 18px 10px;
      cursor: pointer;
    }
    /*用户*/
    .user-con {
      width: 45px;
      height: 45px;
      margin-top: 11px;
      cursor: pointer;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    /*日期*/
    .date-con {
      @include font_color("font_color_header");
      min-width: 76px;
      height: 42px;
      margin-top: 14px;
      font-size: 12px;
      font-weight: bold;
      text-align: right;
      margin-right: 10px;
      p {
        height: 20px;
        line-height: 20px;
        margin: 0;
      }
    }
    .r-bar {
      width: calc(100% - 450px);
      /*入口按钮*/
      .entrance-btn {
        margin-top: 22px;
        margin-right: 25px;
      }
      /*标签*/

      .tags-wrap {
        position: relative;
        overflow: hidden;
        width: 1471px;
        .tab-icon {
          display: block;
          position: absolute;
          top: 18px;
          //color: $positive;
          @include font_color("tab_color_header");
          line-height: 40px;
          z-index: 999;
          cursor: pointer;
          font-size: 24px;
          font-weight: bolder;
          &.tab-prev {
            left: 0;
            padding-right: 8px;
          }
          &.tab-next {
            right: 0;
            padding-left: 8px;
          }
        }
        .tag-scroll {
          display: block;
          margin-right: 144px;
          width: 1440px;
          overflow: hidden;
          margin-left: 20px;
        }
        & ul {
          box-sizing: border-box;
          margin: 0;
          white-space: nowrap;
          transition: transform 0.3s;
          text-align: left;
          float: left;
          height: 70px;
          line-height: 70px;
          .tags-li {
            display: inline-block;
            width: 170px;
            height: 40px;
            line-height: 40px;
            overflow: hidden;
            cursor: pointer;
            vertical-align: middle;
            font-size: 16px;
            position: relative;
            //background: #02041bbf;
            @include background_color("background_color_header_tags");
            text-align: center;
            letter-spacing: 1px;
            padding: 0 10px;
            //border: 1px solid #0d3a58;
            @include border_color("border_color_header_tags");
            margin-right: 10px;
            .tags-li-title {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: inline-block;
              width: 100%;
              //color: $header-color;
              @include font_color("tags_color_header");
            }
            .close-current-tag {
              position: absolute;
              right: 0;
              font-weight: normal;
              .iconfont {
                font-size: 18px;
                color: $light;
                margin-right: 5px;
                font-weight: lighter;
              }
            }
            &.active {
              background: none;
              //box-shadow: 2px 2px 3px #114665;
              @include box_shadow("shadow_color_header_tags_chose");
              //border-color: #52a9ff;
              @include border_color("border_color_header_tags_chose");
              .tags-li-title {
                //color: $header-chose-color;
                @include font_color("tags_chose_color_header");
              }
              .close-current-tag {
                .iconfont {
                  //color: #52a9ff;
                  @include font_color("tags_chose_color_header");
                }
              }
            }
          }
        }
      }
    }
  }
  @media screen and (width:3440px) and (height: 1440px )   {
    .el-header .r-bar .tags-wrap {
        width:2800px
      }
      .el-header .r-bar .tags-wrap .tag-scroll{
          width:2600px
        }
    }
    @media screen and (width:3840px) and (height: 1080px )   {
      .el-header .r-bar .tags-wrap {
        width:3407px
      }
      .el-header .r-bar .tags-wrap .tag-scroll{
          width:3300px
        }
    }
</style>
